"use client";
import { jsx } from "react/jsx-runtime";
import { Container, rem, Center } from "@mantine/core";
import { useWindowScroll, useViewportSize } from "@mantine/hooks";
import { useState, useRef, useEffect } from "react";
import '../../../../../assets/BreakingBanner.css';const root = "_root_svgmu_2";
const BreakingBannerStyles = {
  root
};
const BreakingBanner = (props) => {
  const { content, mod, style, ...rest } = props;
  const [scroll] = useWindowScroll();
  const resize = useViewportSize();
  const [move, setMove] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      setMove(ref.current.getBoundingClientRect().height);
    }
  }, [resize]);
  return /* @__PURE__ */ jsx(
    Container,
    {
      ...rest,
      fluid: true,
      ref,
      className: BreakingBannerStyles.root,
      mod: { scrolled: scroll.y >= 20, ...mod },
      style: { ...style, "--passed-move": rem(-move) },
      children: /* @__PURE__ */ jsx(Center, { children: content })
    }
  );
};
export {
  BreakingBanner as default
};
